module.exports = __webpack_public_path__ + "media/click.81d0f95a.mp3";